import React, { useState, useEffect } from "react";
import styles from "../../styles/CompanyManagement/CompanyDetails.module.css";
import { FiEdit3 } from "react-icons/fi";
import { getCompany, updateCompany } from "../../utils/api";

const CustomerBase = ({ companyId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    countriesSellingIn: "",
    targetAudience: "",
    customerPainPoints: "",
    customerDesires: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch company data on mount or when companyId changes
  useEffect(() => {
    if (!companyId) return;
    setLoading(true);
    setError(null);
    getCompany(companyId)
      .then((company) => {
        const customerBase =
          company.additional_infos?.customer_base || {};
        setFormData({
          countriesSellingIn: customerBase.countriesSellingIn || "",
          targetAudience: customerBase.targetAudience || "",
          customerPainPoints: customerBase.customerPainPoints || "",
          customerDesires: customerBase.customerDesires || "",
        });
      })
      .catch((err) => setError("Failed to load data."))
      .finally(() => setLoading(false));
  }, [companyId]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = async () => {
    if (!companyId) return;
    setLoading(true);
    setError(null);
    try {
      // Fetch latest company data to merge additional_infos
      const company = await getCompany(companyId);
      const additional_infos = { ...company.additional_infos };
      additional_infos.customer_base = { ...formData };
      await updateCompany(companyId, { 
        company: { 
          additional_infos 
        } 
      });
      setIsEditing(false);
    } catch (err) {
      setError("Failed to save data.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  return (
    <div className="company-management-card">
      <div className={styles.detailsHeader}>
        <span className={styles.detailsHeading}>Customer base</span>
        {!isEditing ? (
          <button className={styles.editBtn} onClick={handleEditClick} disabled={loading}>
            <FiEdit3 /> Edit
          </button>
        ) : (
          <button className={styles.saveBtn} onClick={handleSaveClick} disabled={loading}>
            Save
          </button>
        )}
      </div>
      <div className={styles.separator} />
      {error && <div className={styles.error}>{error}</div>}
      {loading ? (
        <div className={styles.detailsContent}>Loading...</div>
      ) : (
        <div className={styles.detailsContent}>
          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Countries selling in</span>
            {isEditing ? (
              <input
                type="text"
                name="countriesSellingIn"
                value={formData.countriesSellingIn}
                onChange={handleChange}
              />
            ) : (
              <p>{formData.countriesSellingIn}</p>
            )}
          </div>

          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Target audience</span>
            {isEditing ? (
              <input
                type="text"
                name="targetAudience"
                value={formData.targetAudience}
                onChange={handleChange}
              />
            ) : (
              <p>{formData.targetAudience}</p>
            )}
          </div>

          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Customer pain points</span>
            {isEditing ? (
              <input
                type="text"
                name="customerPainPoints"
                value={formData.customerPainPoints}
                onChange={handleChange}
              />
            ) : (
              <p>{formData.customerPainPoints}</p>
            )}
          </div>

          <div className={styles.detailItem}>
            <span className={styles.detailLabel}>Customer desires</span>
            {isEditing ? (
              <input
                type="text"
                name="customerDesires"
                value={formData.customerDesires}
                onChange={handleChange}
              />
            ) : (
              <p>{formData.customerDesires}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
export default CustomerBase;
